'use client';

//* HOC's
import { withLanguageContext } from '@/context';

//* Helpers
import { config } from '@/helpers';

//* Components
import Page from '@/components/common/Page';
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import Editor from '@/components/common/Editor';
import TopBar from '@/components/pages/shop/TopBar';
import ShareLink from '@/components/common/ShareLink';
import Container from '@/components/common/Container';

//* Style
import BlogIndividualStyle from 'styles/pages/BlogIndividualStyle';

const PostTemplate = ({ post, translate }) => {
    return (
        <Page>
            <BlogIndividualStyle>
                <Container>
                    <TopBar breadcrumbs={[{ name: 'blog', url: config.routes.blog.path }, { name: post.title }]} />
                </Container>

                <Container
                    full
                    section
                    className={'blog-individual-container'}>
                    <Text
                        className={'h1 font-futura-semibold'}
                        text={post.title}
                    />

                    <div className='date-author-wrap'>
                        <div className='read-time-wrap'>
                            <Icon
                                className={'p'}
                                name={'time'}
                            />

                            <Text className={'h4 font-futura-medium'}>{post.reading_time}</Text>
                        </div>

                        <Text className={'h4 font-futura-light darkGrey'}>{`${translate('by')}: ${post.author} / ${post.date}`}</Text>
                    </div>

                    <div className='content-wrap'>
                        <Editor data={post.description} />

                        <div className='share-wrap'>
                            <ShareLink className={'blog-share'} />
                        </div>
                    </div>
                </Container>
            </BlogIndividualStyle>
        </Page>
    );
};

export default withLanguageContext(PostTemplate, ['translate']);
